import type { Capability } from '@taler/api-client'

/** Reading the screen and established relationships. A PARTNER needs this to start a transfer. */
export function canViewRelationships(can: (capability: Capability) => boolean): boolean {
  return can('TRANSFER')
}

/** Propose, accept and decline. The backend rejects each without LEDGER_SETTINGS_MANAGE. */
export function canManageRelationships(can: (capability: Capability) => boolean): boolean {
  return can('LEDGER_SETTINGS_MANAGE')
}
